import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IExploreState {
    error: boolean;
    isLoading: boolean;
    data: any;
    success: boolean;
    orderCreated: boolean;
    orderId: string;
    promoCodeAmount: number;
    promoCodeVerified: boolean;
    appliedRefund: boolean;
    promoCodeError: boolean;
    showRefundPopup: boolean;
}

const initialState: IExploreState = {
    error: false,
    isLoading: false,
    data: [],
    success: false,
    orderCreated: false,
    orderId: '',
    promoCodeAmount: 0,
    promoCodeVerified: false,
    appliedRefund: false,
    promoCodeError: false,
    showRefundPopup: false
};

export const eventsRedux = createSlice({
    name: "eventsRedux",
    initialState,
    reducers: {
        setEventState: (state: any, action: PayloadAction<{ key: string; value: any }>) => {
            const newState = {
                ...state,
            };
            newState[action.payload.key] = action.payload.value;
            return newState;
        },
        registerUserForEventsRequest: (state: any, action: any) => {
            const newState = {
                ...state,
                isLoading: true,
                showRefundPopup: false
            };
            return newState;
        },
        registerUserForEventsSuccess: (state: any, action: any) => {
            console.log(action.payload, "successRedux")
            const newState = {
                ...state,
                isLoading: false,
                success: true,
                showRefundPopup: false
            };
            return newState;
        },
        registerUserForEventsError: (state: any, action: any) => {
            console.log(action.payload, "ErrorRedux")
            const newState = {
                ...state,
                isLoading: false,
                success: false,
                showRefundPopup: action.payload?.statusCode === 409 ? true : false
            };
            return newState;
        },
        createRazorpayOrderRequest: (state: any, action: any) => {
            const newState = {
                ...state,
                isLoading: true,
            };
            return newState;
        },
        createRazorpayOrderSuccess: (state: any, action: any) => {
            const newState = {
                ...state,
                isLoading: false,
                orderCreated: true,
                data: action.payload?.data,
                orderId: action.payload?.data?.id
            };
            return newState;
        },
        createRazorpayOrderError: (state: any, action: any) => {
            const newState = {
                ...state,
                isLoading: false,
                orderCreated: false,
                data: [],
                orderId: ''
            };
            return newState;
        },
        verifyPromoCodeRequest: (state: any, action: any) => {
            const newState = {
                ...state,
                isLoading: true,
                promoCodeError: false,
                promoCodeVerified: false,
            };
            return newState;
        },
        verifyPromoCodeSuccess: (state: any, action: any) => {
            const newState = {
                ...state,
                isLoading: false,
                promoCodeAmount: action.payload.data,
                promoCodeVerified: true,
                promoCodeError: false
            };
            return newState;
        },
        verifyPromoCodeError: (state: any, action: any) => {
            const newState = {
                ...state,
                isLoading: false,
                promoCodeAmount: 0,
                promoCodeVerified: false,
                promoCodeError: true
            };
            return newState;
        },
        getRefundRequest: (state: any, action: any) => {
            const newState = {
                ...state,
                isLoading: true,
            };
            return newState;
        },
        getRefundSuccess: (state: any, action: any) => {
            const newState = {
                ...state,
                isLoading: false,
                appliedRefund: true
            };
            return newState;
        },
        getRefundError: (state: any, action: any) => {
            const newState = {
                ...state,
                isLoading: false,
                appliedRefund: false
            };
            return newState;
        },
    },
});

export const { setEventState, registerUserForEventsRequest, registerUserForEventsSuccess, registerUserForEventsError,
    createRazorpayOrderRequest, createRazorpayOrderSuccess, createRazorpayOrderError,
    verifyPromoCodeRequest, verifyPromoCodeSuccess, verifyPromoCodeError,
    getRefundRequest, getRefundSuccess, getRefundError } = eventsRedux.actions;


export default eventsRedux.reducer;